// extracted by mini-css-extract-plugin
module.exports = {"container":"CardWithImage_container__XX0ic","image":"CardWithImage_image__lYtVI","linkContainer":"CardWithImage_linkContainer__EnIrL"};